<template>
<div class="editor-wrapper">
  <div class="editor">
    <div class="header">
      Nuevo post:
      <div class="button" @click="create">{{ $route.query.post ? 'Actualizar' : 'Crear'}}</div>
    </div>
    <div class="post-data">
      <div class="column">
        <div class="label">
          <div class="label-text">Nombre</div>
          <base-input
            v-model="title"
            type="text" />
        </div>
        <div class="label">
          <div class="label-text">Resumen</div>
          <base-input
            v-model="summary"
            type="text" />
        </div>
      </div>
      <div class="column">
        <div class="blog-image">
          <div class="form-label">Imagen del blog:</div>
          <div class="image-upload">
            <div v-if="imageUrl" class="image" :style="{ backgroundImage: `url(${imageUrl})` }"></div>
            <label class="label-file">
              <svg aria-hidden="true" data-prefix="fas" data-icon="upload" class="svg-inline--fa fa-upload fa-w-16" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"></path></svg>
              Subir imagen
              <input type="file" @change="uploadImage($event)">
            </label>
          </div>
        </div>
      </div>
    </div>
    <Editor @update="(ct) => {myHtml = ct}" :initialContent="myHtml" />
  </div>
</div>
</template>
<script>
import axios from 'axios';
import { createNamespacedHelpers } from 'vuex';
import BaseInput from '@/components/base/BaseInput.vue';
import Editor from '@/components/Editor.vue';

const { mapActions } = createNamespacedHelpers('blog');

export default {
  data() {
    return {
      title: '',
      summary: '',
      imageUrl: '',
      myHtml: null,
    };
  },
  components: {
    BaseInput,
    Editor,
  },
  methods: {
    create() {
      const data = {
        title: this.title,
        summary: this.summary,
        imageUrl: this.imageUrl,
        content: this.myHtml,
      };
      if (this.$route.query.post) {
        this.editPost({
          id: this.$route.query.post,
          data,
        }).then(() => {
          this.$router.push('/admin/blog');
        });
      } else {
        this.createPost(data).then(() => {
          this.$router.push('/admin/blog');
        });
      }
    },
    uploadImage(event) {
      const fd = new FormData();
      const file = event.target.files[0];
      const url = `${process.env.VUE_APP_SERVER_URL}/public-upload`;
      fd.append('image', file);
      axios.post(url, fd)
        .then(({ data }) => {
          this.imageUrl = data.src;
        });
    },
    ...mapActions([
      'createPost',
      'getPost',
      'editPost',
    ]),
  },
  mounted() {
    if (this.$route.query.post) {
      this.getPost(this.$route.query.post)
        .then((response) => {
          this.title = response.data.title;
          this.summary = response.data.summary;
          this.imageUrl = response.data.imageUrl;
          this.myHtml = response.data.content;
        });
    } else {
      this.myHtml = '';
    }
  },
};
</script>

<style lang="scss" scoped>
.editor-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 100px;
}
.editor {
  width: 800px;
}
.header {
  margin-bottom: 24px;
  font-weight: bold;
  font-size: 28px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    color: #2c70c1;;
  }
}
.button {
  background-color: #2c70c1;
  color: white;
  padding: 14px 40px;
  display: flex;
  width: fit-content;
  justify-content: center;
  font-weight: bolder;
  font-size: 15px;
  text-transform: uppercase;
  cursor: pointer;
  border-radius: 4px;
}

.label-file {
  font-family: 'Roboto', sans-serif;
  background-color: #2c70c1;
  color: white;
  font-size: 14px;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 9px 12px;

  svg {
    height: 14px;
    width: 14px;
    margin-right: 12px;
  }
}
input[type=file] {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.blog-image {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.form-label {
  display: flex;
  flex-direction: column;
  padding: 8px 0;
  font-size: 14px;
  font-family: 'Roboto', sans-serif;
  margin-bottom: 10px;
}
.image {
  min-width: 160px;
  width: 160px;
  max-width: 1600px;
  min-height: 80px;
  height: 80px;
  max-height: 80px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  margin-right: 26px;
}
.image-upload {
  display: flex;
  align-items: center;
}
.post-data {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.column {
  width: 45%;
}
.label {
  width: 100%;
  margin-bottom: 20px;
}
.label-text {
  line-height: 18px;
  margin-bottom: 12px;
}
@media only screen and (max-width: 800px) {
  .editor {
    width: 95%;
  }
}
@media only screen and (max-width: 550px) {
  .post-data {
    flex-wrap: wrap;
  }
  .column {
    width: 95%;
    margin-bottom: 15px;
  }
}
</style>

